(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-form-handler"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';

  if (window.__lpFormHandlerInit) return;
  window.__lpFormHandlerInit = true;

  var ZOHO_ENDPOINT = 'https://forms.zohopublic.com/elmadarsah/form/LeadForm/formperma/rpylHSDk64TcLrZpNIR72O3N4vYjvfytvbnqBgv0CbA/htmlRecords/submit';

  var COOKIE_PREFIX = "zf_";
  var TTL_DAYS = 30;

  var CLICK_ID_KEYS = ["gclid", "fbclid", "ttclid", "ScCid"];

  var CLICK_ID_MAP = {
    gclid:  "SingleLine3",
    fbclid: "SingleLine4",
    ttclid: "SingleLine5",
    ScCid:  "SingleLine6"
  };

  var UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  var ALL_PARAMS = UTM_PARAMS.concat(CLICK_ID_KEYS);

  function setTrackingCookie(name, value) {
    var expires = new Date();
    expires.setDate(expires.getDate() + TTL_DAYS);
    document.cookie = COOKIE_PREFIX + name + "=" + encodeURIComponent(value) + "; expires=" + expires.toUTCString() + "; path=/";
  }

  function deleteTrackingCookie(name) {
    document.cookie = COOKIE_PREFIX + name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  }

  function getTrackingCookie(name) {
    var fullName = COOKIE_PREFIX + name + "=";
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
      if (cookies[i].indexOf(fullName) === 0) {
        return decodeURIComponent(cookies[i].substring(fullName.length));
      }
    }
    return "";
  }

  function decodeParam(str) {
    try {
      return decodeURIComponent(str.replace(/\+/g, " "));
    } catch (e) {
      return str;
    }
  }

  var trackingData = {};

  // 1. Detect fresh click ID to clear stale ones from other platforms
  var freshClickId = null;
  try {
    var urlCheck = new URLSearchParams(window.location.search);
    for (var ci = 0; ci < CLICK_ID_KEYS.length; ci++) {
      if (urlCheck.get(CLICK_ID_KEYS[ci])) {
        freshClickId = CLICK_ID_KEYS[ci];
        break;
      }
    }
  } catch(e) {
    var qsCheck = window.location.search.substring(1);
    if (qsCheck) {
      for (var ci2 = 0; ci2 < CLICK_ID_KEYS.length; ci2++) {
        if (qsCheck.indexOf(CLICK_ID_KEYS[ci2] + "=") > -1) {
          freshClickId = CLICK_ID_KEYS[ci2];
          break;
        }
      }
    }
  }
  if (freshClickId) {
    for (var di = 0; di < CLICK_ID_KEYS.length; di++) {
      if (CLICK_ID_KEYS[di] !== freshClickId) {
        deleteTrackingCookie(CLICK_ID_KEYS[di]);
      }
    }
  }

  // 2. Grab UTMs and Click IDs from URL first, then fallback to cookies
  try {
    var urlParams = new URLSearchParams(window.location.search);
    ALL_PARAMS.forEach(function(param) {
      var urlVal = urlParams.get(param);
      if (urlVal) {
        trackingData[param] = urlVal;
        setTrackingCookie(param, urlVal);
      } else {
        var cookieVal = getTrackingCookie(param);
        if (cookieVal) trackingData[param] = cookieVal;
      }
    });
  } catch(e) {
    var qs = window.location.search.substring(1);
    if (qs) {
      var pairs = qs.split("&");
      for (var i = 0; i < pairs.length; i++) {
        var idx = pairs[i].indexOf("=");
        var k, v;
        if (idx > -1) {
          k = decodeParam(pairs[i].substring(0, idx));
          v = decodeParam(pairs[i].substring(idx + 1));
        } else {
          k = decodeParam(pairs[i]);
          v = "";
        }
        if (v && ALL_PARAMS.indexOf(k) > -1) {
          trackingData[k] = v;
          setTrackingCookie(k, v);
        }
      }
    }
    ALL_PARAMS.forEach(function(param) {
      if (!trackingData[param]) {
        var cv = getTrackingCookie(param);
        if (cv) trackingData[param] = cv;
      }
    });
  }

  // 3. Landing URL — store full URL; persist even without query params
  var currentUrl = window.location.href;
  var hasParams = currentUrl.indexOf("?") > -1;
  if (hasParams || !getTrackingCookie("landing_url")) {
    setTrackingCookie("landing_url", currentUrl);
    trackingData["landing_url"] = currentUrl;
  } else {
    var storedUrl = getTrackingCookie("landing_url");
    trackingData["landing_url"] = storedUrl || currentUrl;
  }


  // ==========================================
  // FORM HANDLING LOGIC
  // ==========================================
  var countryNames = {
    sa: 'Saudi Arabia', ae: 'United Arab Emirates', eg: 'Egypt',
    kw: 'Kuwait', bh: 'Bahrain', qa: 'Qatar',
    om: 'Oman', jo: 'Jordan', iq: 'Iraq',
    lb: 'Lebanon', us: 'United States', gb: 'United Kingdom'
  };

  function setHiddenField(form, name, value) {
    var fields = form.querySelectorAll('input[type="hidden"]');
    var input = null;
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].name === name) {
        input = fields[i];
        break;
      }
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value || '';
  }

  // Shopify can render this snippet before every lead form exists on the page.
  document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-lp-form]')) {
        form = e.target && e.target.closest ? e.target.closest('form[data-lp-form]') : null;
      }
      if (!form) return;

      var useNativeSubmit = form.dataset.lpNativeSubmit === 'true';
      if (!useNativeSubmit) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }

      var btn = form.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      var loadingText = form.dataset.loadingLabel || '...';
      if (btn) {
        btn.disabled = true;
        btn.textContent = loadingText;
      }

      var fullName  = (form.querySelector('[name="name"]') || form.querySelector('[name="first_name"]') || {}).value || '';
      var lastNameInput = form.querySelector('[name="last_name"]');
      if (lastNameInput && lastNameInput.value) {
          fullName += ' ' + lastNameInput.value;
      }
      fullName = fullName.trim();

      var organizationVal = (form.querySelector('[data-organization-input]') || form.querySelector('[name="organization"]') || {}).value || '';
      organizationVal = organizationVal.trim();

      var subjectEl = form.querySelector('[name="subject"]') || form.querySelector('[name="service"]');
      var subjectVal = subjectEl ? subjectEl.value.trim() : '';
      var formLocation = form.dataset.lpForm || form.id;
      if (formLocation === 'new-crm-form') {
        if (!organizationVal) organizationVal = 'WebsiteLead';
        if (!subjectVal) subjectVal = 'WebsiteLead';
      }
      
      var emailVal  = (form.querySelector('[name="email"]') || {}).value || '';
      emailVal = emailVal.trim();
      
      var phoneEl   = form.querySelector('[data-phone-input]') || form.querySelector('[name="phone"]');
      var phoneVal  = phoneEl ? phoneEl.value.trim() : '';

      var pickerWrap = form.closest('.lp-hero__form-card, .lp-bottom__form-card, section, .form-row, form');
      var codeSpan   = pickerWrap ? pickerWrap.querySelector('[data-country-code]') : null;
      var codeSelect = pickerWrap ? pickerWrap.querySelector('select[name="country_code"]') : null;
      var codeInput  = pickerWrap ? pickerWrap.querySelector('input[name="country_code"]') : null;
      
      var countryCode = codeSpan ? codeSpan.textContent.trim() : (codeSelect ? codeSelect.value : (codeInput ? codeInput.value : '+971'));
      if (!countryCode) countryCode = '+971';
      var selectedOpt = pickerWrap ? pickerWrap.querySelector('.lp-phone-picker__option[aria-selected="true"]') : null;
      
      var countryISO = 'ae';
      if (selectedOpt) {
          countryISO = selectedOpt.dataset.iso;
      } else if (codeSelect && codeSelect.options[codeSelect.selectedIndex]) {
          countryISO = codeSelect.options[codeSelect.selectedIndex].getAttribute('data-iso') || 'ae';
      } else if (codeInput) {
          countryISO = codeInput.getAttribute('data-iso') || 'ae';
      }
      
      var countryName = countryNames[countryISO] || 'United Arab Emirates';
      if (!fullName || !phoneVal || !emailVal) {
        e.preventDefault();
        showToast(form, 'error', form.dataset.requiredMessage || 'Please fill in all required fields.');
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
        return;
      }

      if (!useNativeSubmit && form.dataset.lpSubmitting === 'true') {
        return;
      }
      if (!useNativeSubmit) {
        form.dataset.lpSubmitting = 'true';
      }

      var nameParts = fullName.split(' ');
      var firstName = nameParts[0] || fullName;
      var lastName  = nameParts.slice(1).join(' ') || '-';

      var fullPhone = countryCode + phoneVal;
      var landingUrl = trackingData.landing_url || window.location.href;

      if (useNativeSubmit) {
        setHiddenField(form, 'SingleLine', firstName);
        setHiddenField(form, 'SingleLine1', lastName);
        setHiddenField(form, 'SingleLine2', organizationVal);
        setHiddenField(form, 'PhoneNumber_countrycode', fullPhone);
        setHiddenField(form, 'Dropdown', countryName);
        setHiddenField(form, 'Email', emailVal);
        setHiddenField(form, 'subject', subjectVal);
        setHiddenField(form, 'zf_referrer_name', landingUrl);
        setHiddenField(form, 'referrername', window.location.href);
        setHiddenField(form, 'zf_redirect_url', 'https://elmadrasah.com/pages/thank-you');
        setHiddenField(form, 'zc_gad', trackingData.gclid || '');
        setHiddenField(form, 'utm_source', trackingData.utm_source || '');
        setHiddenField(form, 'utm_medium', trackingData.utm_medium || '');
        setHiddenField(form, 'utm_campaign', trackingData.utm_campaign || '');
        setHiddenField(form, 'utm_term', trackingData.utm_term || '');
        setHiddenField(form, 'utm_content', trackingData.utm_content || '');
        setHiddenField(form, 'SingleLine3', trackingData.gclid || '');
        setHiddenField(form, 'SingleLine4', trackingData.fbclid || '');
        setHiddenField(form, 'SingleLine5', trackingData.ttclid || '');
        setHiddenField(form, 'SingleLine6', trackingData.ScCid || '');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'lp_lead_submit',
          form_location: formLocation,
          lead_name: fullName,
          lead_email: emailVal,
          lead_phone: fullPhone,
          lead_country: countryName,
          lead_organization: organizationVal,
          lead_subject: subjectVal
        });

        try { document.charset = 'UTF-8'; } catch(e) {}
        return;
      }

      // --- Submit to Zoho via hidden iframe ---
      var iframeName = 'lp-zoho-iframe-' + Date.now();
      var iframe = document.createElement('iframe');
      iframe.name = iframeName;
      iframe.style.display = 'none';

      var submitted = false;
      var hasSubmittedToZoho = false;
      var redirectTimer;

      iframe.addEventListener('load', function() {
        try {
          if (iframe.contentWindow && iframe.contentWindow.location.href === 'about:blank') return;
        } catch(err) {}
        if (!hasSubmittedToZoho || submitted) return;
        submitted = true;
        clearTimeout(redirectTimer);
        doRedirect();
      });

      document.body.appendChild(iframe);

      var hiddenForm = document.createElement('form');
      hiddenForm.method = 'POST';
      hiddenForm.action = ZOHO_ENDPOINT;
      hiddenForm.target = iframeName;
      hiddenForm.acceptCharset = 'UTF-8';
      hiddenForm.enctype = 'multipart/form-data';
      hiddenForm.style.display = 'none';

      var fields = {
        'SingleLine': firstName,
        'SingleLine1': lastName,
        'SingleLine2': organizationVal,
        'PhoneNumber_countrycode': fullPhone,
        'Dropdown': countryName,
        'Email': emailVal,
        'subject': subjectVal,
        'zf_redirect_url': 'https://elmadrasah.com/pages/thank-you',
        'zf_referrer_name': landingUrl,
        'referrername': window.location.href,
        'zc_gad': trackingData.gclid || '',
        'utm_source': trackingData.utm_source || '',
        'utm_medium': trackingData.utm_medium || '',
        'utm_campaign': trackingData.utm_campaign || '',
        'utm_term': trackingData.utm_term || '',
        'utm_content': trackingData.utm_content || '',
        'SingleLine3': trackingData.gclid || '',
        'SingleLine4': trackingData.fbclid || '',
        'SingleLine5': trackingData.ttclid || '',
        'SingleLine6': trackingData.ScCid || ''
      };

      for (var key in fields) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = fields[key];
        hiddenForm.appendChild(input);
      }

      document.body.appendChild(hiddenForm);
      hasSubmittedToZoho = true;
      hiddenForm.submit();

      // --- Fire analytics tracking ---

      if (typeof mixpanel !== 'undefined') {
        try {
          mixpanel.track('Lead Form', {
            name: fullName,
            email: emailVal,
            phone: fullPhone,
            organization: organizationVal,
            subject: subjectVal,
            source: window.location.pathname,
            form_location: formLocation,
            '$userType': 'customer',
            'utm_source': trackingData.utm_source,
            'utm_medium': trackingData.utm_medium,
            'utm_campaign': trackingData.utm_campaign
          });

          if (emailVal) {
            mixpanel.identify(emailVal);
            mixpanel.people.set({
              '$email': emailVal,
              '$name': fullName,
              '$phone': fullPhone,
              '$userType': 'customer'
            });
          }
        } catch(err) {}
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'lp_lead_submit',
        form_location: formLocation,
        lead_name: fullName,
        lead_email: emailVal,
        lead_phone: fullPhone,
        lead_country: countryName,
        lead_organization: organizationVal,
        lead_subject: subjectVal
      });

      // Safety net only — not the expected path
      redirectTimer = setTimeout(function() {
        if (!submitted) {
          submitted = true;
          doRedirect();
        }
      }, 15000);

      function doRedirect() {
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText;
        }
        try { document.body.removeChild(hiddenForm); } catch(e) {}
        try { document.body.removeChild(iframe); } catch(e) {}
        window.location.href = 'https://elmadrasah.com/pages/thank-you';
      }
  }, true);

  function showToast(form, type, message) {
    var existing = form.parentElement.querySelector('.lp-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'lp-toast lp-toast--' + type;
    toast.textContent = message;
    form.parentElement.insertBefore(toast, form.nextSibling);

    setTimeout(function() {
      toast.classList.add('lp-toast--fade');
      setTimeout(function() { toast.remove(); }, 300);
    }, 4000);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
